import { render, staticRenderFns } from "./ForgetPasswordView.vue?vue&type=template&id=37ac1d5f&"
import script from "./ForgetPasswordView.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports